<template>
  <div class="app-wrapper">
    <!-- 头部导航开始 -->
    <nav-bar class="nav-bar" :logoPath="logoPath"></nav-bar>

    <div class="main-container">
      <!-- 左菜单开始 -->
      <side-bar class="side-bar"></side-bar>

      <!-- tags标签栏 -->
      <!-- <tags-view id="tags-view" class="main-top-container"/> -->

      <!-- 主应用开始 -->
      <!-- <app-main :class="[isActive ? activeClass : errorClass, errorClass]"></app-main> -->

      <!-- 主应用开始 -->
      <app-main :class="this.$root.isActiveApp == false ? 'app-main' : 'app-main-left'"></app-main>

    </div>
  </div>
</template>

<script>
  import NavBar from '../navbar'
  import SideBar from '../sidebar'
  import AppMain from './AppMain'

  export default {
    name: 'Layout',
    components: {
      NavBar,
      SideBar,
      AppMain,
    },
    data() {
      return {
        logoPath: require('assets/img/roboy.png')
      }
    }
  }
</script>

<style scoped>
  .app-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .nav-bar {
    height: 40px;
  }

  .side-bar {
    position: fixed;
    top: 40px;
    left: 0;
    height: 100%;
    width: 1%;
    overflow: hidden;
  }

  /* 页面滚动解决处理：1 */
  .main-container {
    height: 100%;
  }

  /* 页面滚动解决处理：2 */
  .main-top-container {
    height: 5%;
  }

  /* 页面滚动解决处理：3 */
  .app-main {
    overflow-y: scroll;
    min-height: calc(100vh - 50px);
    width: 100%;
    height: 95%;
    position: relative;

  }

  .app-main-left {
    width: 107%;
    margin-left: -7%;
/*    overflow-y: scroll;
    position: relative; */
  }

  /* #tags-view,
  .app-main-left {
    float: left;
   margin-left: 200px;
  } */
</style>
